import { render, staticRenderFns } from "./AmplifyAuthentication.vue?vue&type=template&id=8be0837e&scoped=true&"
import script from "./AmplifyAuthentication.vue?vue&type=script&lang=js&"
export * from "./AmplifyAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./AmplifyAuthentication.vue?vue&type=style&index=0&id=8be0837e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be0837e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
